"use client";

import { CookiesScripts } from "@/components/common/cookies-script/cookies-scripts";
import { GoogleDefaultAnalytics } from "@/components/common/cookies-script/scripts/analytics/google-default-analytics";
import { FacebookDefaultAdvertising } from "@/components/common/cookies-script/scripts/advertising/facebook-default-advertising";

export const CookiesSetup = () => {
  return (
    <>
      <CookiesScripts />
      <GoogleDefaultAnalytics />
      <FacebookDefaultAdvertising />
    </>
  );
};
